import { render, staticRenderFns } from "./campaigns-create-page.vue?vue&type=template&id=4cad2681&"
import script from "./campaigns-create-page.vue?vue&type=script&lang=js&"
export * from "./campaigns-create-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports